/**
 * Created by fers on 24/09/2017.
 */

import Expression from '../../expression/Expression.react';
import ExpressionGroup from '../../expression/ExpressionGroup.react';
import { Form } from 'formsy-react-components';
import {defineMessages, IntlShape} from 'react-intl';
import LoadingButton from '../../fw/LoadingButton.react';
import * as Tool from '../../fw/Tool';
import types from '../../../common/model-api/types';

import React from 'react';
import PropTypes from 'prop-types';

export const messages = defineMessages({
    textarea: {id: 'DataSourceManualQueryAdd.textarea', 'defaultMessage': 'DatiQuery'},
    save: {id: 'DataSourceManualQueryAdd.update', 'defaultMessage': 'Save Search'},
});

export default class SearchActionExpressionEditor extends React.Component {

    static propTypes = {
        actionDef: PropTypes.object,
        dataSource: PropTypes.object,
        intl: PropTypes.object,
        mapping: PropTypes.object,
        parentDataSource: PropTypes.object.isRequired,
        save: PropTypes.func,
    };

    constructor(props) {
        super(props);

        let isOk = true;
        for (let row of Object.keys(props.mapping)) {
            if (!props.mapping[row]) {
                isOk = false;
            }
        }

        this.state = {
            canSubmit: isOk,
            mapping: props.mapping,
        };
    }

    possibleVariableGroups = () => {
        return ([{
            id: "",
            name: ""
        }]);
    };

    possibleVariables = (group) => {
        if (group.id === "") {
            return this.props.parentDataSource.mappedFields;
        }
    };

    enableButton = () => {
        this.setState({
            canSubmit: true
        });
    };

    disableButton = () => {
        this.setState({
            canSubmit: false
        });
    };

    add = () => {
        return this.props.save(this.state.mapping);
    };

    render() {
        let handledInputKeys = {};

        let actionDef = this.props.actionDef;

        return (<Form
            onInvalid={this.disableButton}
            onValid={this.enableButton}
            onValidSubmit={this.add}
        >

            <ExpressionGroup possibleVariableGroups={this.possibleVariableGroups} possibleVariables={this.possibleVariables}>
                <table className="table">
                    <tbody>
                    {actionDef.actionInputDefs.edges.map(({node: actionInputDef}, idx) => {
                        if (handledInputKeys[actionInputDef.key]) {
                            return null;
                        } else {
                            handledInputKeys[actionInputDef.key] = true;
                        }

                        let afterChange = (value) => {
                            let newMapping = {...this.state.mapping};
                            let key = actionInputDef.key;
                            if (actionInputDef.fieldDef_id) {
                                key = actionInputDef.fieldDef_id;
                            }
                            newMapping[key] = value;

                            let canSubmit = true;
                            let mappedSomething = false;
                            /* check if everything is mapped */
                            for (let {node: actionInputDef} of actionDef.actionInputDefs.edges) {
                                let key = actionInputDef.key;
                                if (actionInputDef.fieldDef_id) {
                                    key = actionInputDef.fieldDef_id;
                                }
                                let isMapped = false;

                                if (newMapping[key] && newMapping[key] !== "") {
                                    mappedSomething = true;
                                    isMapped = true;
                                }

                                if (actionInputDef.required && !isMapped) {
                                    canSubmit = false;
                                }
                            }

                            this.setState({
                                mapping: newMapping,
                                canSubmit: mappedSomething && canSubmit ? true : false
                            });
                        };

                        return (
                            <tr key={idx}>
                                <td>{actionInputDef.name ? actionInputDef.name : <code>{actionInputDef.key}</code>} ({Tool.getFormatted(types['actionInputDefs'], 'type', this.props.intl.formatMessage, actionInputDef)})</td>
                                <td><Expression afterChange={afterChange} expression={actionInputDef.fieldDef_id && this.state.mapping[actionInputDef.fieldDef_id] ? this.state.mapping[actionInputDef.fieldDef_id] : this.state.mapping[actionInputDef.key]}/></td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </ExpressionGroup>

            <LoadingButton className="btn btn-primary"
                           disabled={!this.state.canSubmit}
                           type="submit">{this.props.intl.formatMessage(messages.save)}</LoadingButton>
        </Form>);
    }
}
